<template>
  <div class="articlePage">
    <job-header-simple header_title="员工须知"></job-header-simple>
    <p class="title">灵活用工，让企业用工更灵活!</p>
    <p>在当前经济不景气的情况下，企业的成本并没有随之减少，反而是愈发的增加，人才短缺、基层用工紧张仍旧是企业不可避免的问题，在这种情况下，企业HR应该如何完成这个艰难的任务呢？工蚁宝小编告诉您，灵活用工了解一下！</p>
    <img src="./assets/2.png" alt />
    <p>一、什么是灵活用工?</p>
    <p>灵活用工是指企业面临人员编制紧张、季节性人才短缺、独立项目运营的需求、政策因素等难题时，由专业人力资源服务机构外派员工的一种特殊用工形式，人力资源服务机构承担全方位的法定雇主责任，包括招聘、收入发放、培训等，承担所有用人风险。在用工人数、周期、人才筛选方面都非常灵活。</p>
    <p>灵活用工会为用工单位、雇员、雇主带来更多价值，其中关键的是降低企业人力资源成本，从而降低企业运营成本、人力资源部门的固定成本、时间成本、财务费用和管理费用。另外，也可帮助企业转移和降低用工风险，满足了劳动力对工作自由性的需求，也是解决就业难的重要方式。</p>
    <p>二、灵活用工有什么服务项目?</p>
    <p>1、办理用工手续，签订劳动协议及负责协议的管理</p>
    <p>2、外派员工每月工时与用工单位核对确定</p>
    <p>3、处理劳资纠纷</p>
    <p>三、灵活用工需要承担的责任</p>
    <p>1、负责用工单位招聘</p>
    <p>2、为员工办理相关保险，与员工签订劳动协议</p>
    <p>3、负责处理员工劳资纠纷，承担用工责任</p>
    <p>为提升用工的灵活性和弹性，许多大型国企也纷纷采用灵活用工。近年来，民企快速发展，为了规避用工风险和缓解雇佣压力，也越来越多企业采用灵活用工。</p>
    <p>工蚁宝-专业的灵活用工平台，为企业提供多元化的用工服务，帮助企业解决难题，致力于把人力资源变得更简单。</p>
  </div>
</template>

<script>
import jobHeaderSimple from "@/components/header/header.vue";
export default {
  components: {
    jobHeaderSimple
  }
};
</script>

<style lang="less" scoped>
.articlePage{
    padding: 30px 16px 60px 16px;
    background: #fff;
    margin-bottom: -60px;
}
p{
    font-size: 14px;
    line-height: 24px;
    margin-bottom: 10px;

    &.title{
        text-align: center;
        font-size: 18px;
        margin-bottom: 20px;
    }
}

img{
    display: block;
    width:100%;
    height: auto;
    margin: 10px 0 15px;
}
</style>